<template>
    
</template>

<script>
import { api } from '../../utils/requests';

export default {
    data() {
        return {
        }
    },
    created(){
        api.login_native()
    },
}
</script>
